import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        loading: Boolean
    }
    static targets = ['pageTrigger', 'pageLink'];

    initialize() {
        this.loading = false;
        this.createObserver = this.createObserver.bind(this);
    }

    connect() {
        this.createObserver();
    }

    createObserver() {
        if (this.hasPageTriggerTarget) {
            const observer = new window.IntersectionObserver(([entry]) => {
                if (entry.isIntersecting && !this.loading) {
                    this.loadMoreContent();
                }
            }, {
                root: null,
                threshold: 1,
            });
            observer.observe(this.pageTriggerTarget);
        }
    }

    loadMoreContent() {
        const checkResults = parseInt(document.getElementById('checkResults').innerText);
        const currentSize = parseInt(document.getElementById('resultsNumber').value);
        
        if (!this.loading && checkResults >= currentSize) {
            this.loading = true;
            const batchSize = 12;
            document.getElementById('resultsNumber').value = currentSize + batchSize;
            
            setTimeout(() => {
                const submitButton = document.getElementById("submit-button");
                submitButton.setAttribute('data-scrollTrigger', 'true');
                submitButton.click();
                submitButton.removeAttribute('data-scrollTrigger');
                
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            }, 100);
        }
    }
}
